import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";
import router from "@/router";
import userApi from "@/api/userApi";
import User from "@/model/user";

@Module({ namespaced: true })
export default class AuthModule extends VuexModule {
  token = localStorage.getItem("token") || "";
  expired_at = "";
  role = "";
  userLogging: User;
  @Mutation
  setToken(token: string): void {
    this.token = token;
    localStorage.setItem("token", token);
  }
  @Mutation
  setExpiredAt(time: string): void {
    this.expired_at = time;
  }
  @Mutation
  setRole(role: string): void {
    this.role = role;
  }
  @Mutation
  setUserLogging(user: User): void {
    this.userLogging = user;
  }
  @Action({ rawError: true })
  updateToken(token: string): void {
    this.context.commit("setToken", token);
  }
  @Action
  updateExpiredAt(time: string): void {
    this.context.commit("setExpiredAt", time);
  }
  @Action
  updateRole(role: string): void {
    this.context.commit("setRole", role);
  }

  @Action
  async fetchCurrentUser(): Promise<void> {
    if (this.token) {
      const user = await userApi.me();
      this.context.commit("setUserLogging", user);
    }
  }

  @Action
  logout(): void {
    this.context.commit("setToken", "");
    this.context.commit("setExpiredAt", "");
    this.context.commit("setRole", "");
    // this.context.commit("setUserInfor", "");
    router.push({ name: "login" });
  }

  get getToken(): string {
    return this.token;
  }
  get getExpiredAt(): string {
    return this.expired_at;
  }
  get getRole(): string {
    return this.role;
  }

  get getUserLogging(): User {
    return this.userLogging;
  }
}

// export default getModule(AuthModule);
